import Vue from 'vue'
import {
  MdButton,
  MdContent,
  MdCard,
  MdField,
  MdCheckbox,
  MdProgress,
  MdSnackbar,
  MdIcon,
  MdTabs
} from 'vue-material/dist/components'

//import 'vue-material/dist/vue-material.min.css'



export default function materialDesignInitialization() {


  Vue.use(MdButton)

  Vue.use(MdCard)

  Vue.use(MdContent)

  Vue.use(MdField)
  Vue.use(MdCheckbox)

  Vue.use(MdProgress)
  Vue.use(MdSnackbar)

  Vue.use(MdIcon)

  Vue.use(MdTabs)
}


// WEBPACK FOOTER //
// ./lib/brave-vue/materialDesignInitialization.js